<template>
  <div class="relative min-h-screen">
    <form class="pb-40" @submit.prevent="handlePost">
      <div class="flex flex-col items-center pt-6 pb-12 px-8 md:px-32">
        <input ref="inputFile" accept=".png, .jpg, .jpeg" type="file" hidden @change="handleFile" />

        <div
          class="flex items-center justify-center bg-gray-500 text-white w-full h-64 max-w-lg mx-auto cursor-pointer"
          v-if="!file.preview"
          @click="$refs.inputFile.click()"
        >
          <span class="underline">Add Photo</span>
        </div>

        <div class="relative w-full max-w-lg mx-auto h-64" v-else>
          <i
            class="material-icons absolute left-0 text-red-500 ml-2 mt-2 z-50 cursor-pointer"
            v-if="!isLoading"
            @click="clearFile"
          >close</i>

          <img :src="file.preview" class="object-cover w-full h-full" />
        </div>

        <div class="flex w-full max-w-lg mt-6">
          <base-input
            v-model="post.title"
            v-validate="'required|max:255'"
            name="title"
            class="w-1/2"
            placeholder="Post Title"
            :message="errors.first('title')"
            autofocus
          />
          <base-input
            v-model="post.date"
            v-validate="'required|date_format:yyyy/MM/dd|max:255'"
            v-mask="'####/##/##'"
            name="date"
            class="w-1/2 ml-4"
            placeholder="Date Publishing"
            :message="errors.first('date')"
          />
        </div>

        <base-input
          v-model="post.body"
          v-validate="'required|max:3000'"
          name="body"
          type="textarea"
          class="w-full max-w-lg h-40 mt-4"
          placeholder="Enter post content..."
          :message="errors.first('body')"
        />

        <button class="btn btn-blue w-full max-w-lg mt-4" :disabled="isLoading">Post</button>
      </div>
    </form>

    <base-footer class="absolute bottom-0" />
  </div>
</template>

<script>
import "firebase/storage";
import dayjs from 'dayjs';
import uuid from "uuid/v1";
import firebase from "firebase/app";
import { mapState } from "vuex";
import PostService from "@/services/PostService";

export default {
  data() {
    return {
      post: {
        date: dayjs(new Date()).format('YYYY/MM/DD'),
      },
      file: {},
      isLoading: false
    };
  },
  computed: {
    ...mapState("profile", ["address"])
  },
  methods: {
    handleFile(e) {
      const file = e.target.files[0];

      if (file) {
        const extension = file.name.split(".").pop();

        this.file = {
          file,
          preview: URL.createObjectURL(file),
          extension
        };
      }
    },

    clearFile() {
      this.file = {};
      this.$refs.inputFile.value = "";
    },

    async handlePost() {
      try {
        if (this.isLoading) {
          return;
        }

        if (!(await this.$validator.validateAll())) {
          this.$toasted.error("Please check the fields.");
          return;
        }

        this.isLoading = true;

        // Upload photo
        if (this.file.file) {
          const fileName = `${uuid()}.${this.file.extension}`;
          const snapshot = await firebase
            .storage()
            .ref(`forum/${fileName}`)
            .put(this.file.file);

          this.post.filename = fileName;
          this.post.image = await snapshot.ref.getDownloadURL();
        }

        // Create post
        await PostService.create({
          location: this.address,
          ...this.post
        });

        this.$router.push({ name: "posts" });
      } catch (e) {
        this.$setErrorsFromLaravel(e.response.data);
      } finally {
        this.isLoading = false;
      }
    }
  }
};
</script>
